"use strict";

var _classCallCheck = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\classCallCheck.js");

var _createClass = require("C:\\Projects\\far-fruit\\node_modules\\@babel\\runtime\\helpers\\createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bounce = void 0;

var BounceFactor_1 = require("./BounceFactor");

var Bounce = /*#__PURE__*/function () {
  function Bounce() {
    _classCallCheck(this, Bounce);

    this.horizontal = new BounceFactor_1.BounceFactor();
    this.vertical = new BounceFactor_1.BounceFactor();
  }

  _createClass(Bounce, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }

      this.horizontal.load(data.horizontal);
      this.vertical.load(data.vertical);
    }
  }]);

  return Bounce;
}();

exports.Bounce = Bounce;